import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const QuoteCreatedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.QUOTE_CREATED),
  // Might add more types here in the future other than sowChanges
  payload: z.discriminatedUnion("type", [
    z.object({
      type: z.literal("sowChanges"),
      sowChanges: z.string(),
    }),
  ]),
});

export type QuoteCreatedTaskAttempt = z.infer<typeof QuoteCreatedTaskAttemptSchema>;
